import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Geosuggest from 'react-geosuggest'
import styles from './geosuggest.styl'

export default class GeosuggestComp extends Component {
  static propTypes = {
    onSuggestSelect: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    intlKey: PropTypes.string
  }

  static defaultProps = {
    placeholder: 'Start typing...'
  }

  render() {
    const { onSuggestSelect, placeholder, label, intlKey } = this.props

    return (
      <div className="form-group">
        {label &&
          <label htmlFor="geosuggest-input" className="control-label">
            {intlKey
              ? <FormattedMessage id={intlKey} defaultMessage={label} />
              : label}
          </label>}
        <div className="controls">
          <Geosuggest
            name="geosuggest-input"
            onSuggestSelect={onSuggestSelect}
            className={styles.geosuggest}
            inputClassName="form-control"
            placeholder={placeholder}
          />
        </div>
      </div>
    )
  }
}
